import moment from "moment";
import { VOUCHER_STATEMENTS } from "./voucherCategories";

const parseVoucherDate = (dateStr) => {
  const [datePart, timePart] = dateStr.split(" · ");
  const [day, month, year] = datePart.split("/");
  const time = (timePart || "12:00").trim();
  return `${year}-${month}-${day}T${time.replace(":", ":")}:00`;
};

export const mapVoucherStatementsToReceiptItems = (categoryId, { limit, startDate, endDate } = {}) => {
  let items = VOUCHER_STATEMENTS[categoryId] || [];

  if (startDate && endDate) {
    const start = moment(startDate);
    const end = moment(endDate);
    items = items.filter((item) => {
      const itemDate = moment(parseVoucherDate(item.date));
      return itemDate.isBetween(start, end, "day", "[]");
    });
  }

  if (limit) {
    items = items.slice(0, limit);
  }

  const byDay = {};

  items.forEach((item) => {
    const createdAt = parseVoucherDate(item.date);
    const dayKey = moment(createdAt).format("YYYY-MM-DD");

    if (!byDay[dayKey]) byDay[dayKey] = [];

    byDay[dayKey].push({
      id: item.id,
      description: item.title,
      created_at: createdAt,
      amount: item.amountCents,
      balance_before: 0,
      balance_after: 0,
    });
  });

  const dayGroups = Object.keys(byDay)
    .sort((a, b) => b.localeCompare(a))
    .map((day) => ({ [day]: byDay[day] }));

  return { items: dayGroups };
};
